//dev
//export const baseUrl = 'https://app-xqediiaywq-lz.a.run.app/'
//prod
export const baseUrl = 'https://app-qe72a5lrqq-lz.a.run.app/'
//for local emulator
//export const baseUrl = 'http://127.0.0.1:5001/safetrack-dev-29de2/europe-north1/app/'